import { useCallback, useMemo, useRef } from "react";

export default function useSeleccionConCambios(idsSeleccionados = []) {
  const idsInicialesRef = useRef([]);

  // ✅ estable: NO cambia entre renders
  const inicializar = useCallback((ids = []) => {
    idsInicialesRef.current = Array.isArray(ids) ? ids.slice() : [];
  }, []);

  const tieneCambios = useMemo(() => {
    const iniciales = idsInicialesRef.current ?? [];
    const actuales = Array.isArray(idsSeleccionados) ? idsSeleccionados : [];

    if (iniciales.length !== actuales.length) return true;

    const setInicial = new Set(iniciales);
    for (const id of actuales) {
      if (!setInicial.has(id)) return true;
    }
    return false;
  }, [idsSeleccionados]);

  return {
    inicializar,
    tieneCambios,
  };
}
